/* eslint-disable react-hooks/exhaustive-deps */
import AddressAutocomplete from "components/AddressAutocomplete/AddressAutocomplete";
import { CreateChargingAgreementForm, FULL_SERVICE_RENT_PURCHASE_OPTION_ID, MARKET_PRICE_COMPENSATION_ID, NETO_COMPENSATION_ID, RENT_PURCHASE_OPTION_ID } from "components/ChargingAgreements/modals/EditChargingAgreementModal";
import { ChargingPurchaseOption, ChargingStationModel, ChargingThirdPartyCompensationOption } from "components/ChargingAgreements/models";
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import { ChargingPurchaseOptionService } from "services/charging/charging-purchase-option.service";
import { ChargingStationModelService } from "services/charging/charging-station-model.service";
import { ChargingThirdPartyCompensationOptionService } from "services/charging/charging-third-party-compensation-option.service";
import { ChargingPricing } from "components/ChargingPricings/models";
import { onNumberChange } from "helpers";
import { validateCommaSeparatedPersonalIdentificationCodes } from "helpers/validator";
import ChargingStationForm, { EXCLUDED_COMPENSATION_OPTIONS } from "./ChargingStationForm";

interface NewChargingAgreementDeviceFormProps {
    form: CreateChargingAgreementForm;
    setForm: (form: CreateChargingAgreementForm) => void;
    pricing?: ChargingPricing;
    chargerBasedConfig: boolean;
}

export default function NewChargingAgreementDeviceForm(
    { form, setForm, pricing, chargerBasedConfig } : NewChargingAgreementDeviceFormProps
) {
    const [purchaseOptions, setPurchaseOptions] = useState<ChargingPurchaseOption[]>([]);
    const [compensationOptions, setCompensationOptions] = useState<ChargingThirdPartyCompensationOption[]>([]);
    const [stationModels, setStationModels] = useState<ChargingStationModel[]>([]);

    useEffect(() => {
        findPurchaseOptions();
        findCompensationOptions();
        findStationModels();
    }, []);

    const findStationModels = async () => {
        try{
          const res = await ChargingStationModelService.findChargingStationModels();
          setStationModels(
            res
          )
        }catch(e){
          console.error(e);
        }
      }

    const findPurchaseOptions = async () => {
        try{
            const res = await ChargingPurchaseOptionService.findChargingPurchaseOptions();
            setPurchaseOptions(res)
        }catch(e){
            console.error(e);
        }
    }

    const findCompensationOptions = async () => {
        try{
            const res = await ChargingThirdPartyCompensationOptionService.findChargingThirdPartyCompensationOptions();
            setCompensationOptions(res)
        }catch(e){
            console.error(e);
        }
    }

    const purchaseSelectOptions = purchaseOptions.map(opt => ({ value: opt.id, label: opt.name }));
    const purchaseSelectCurrentOption = purchaseSelectOptions.find(opt => opt.value === form.purchaseOptionId);

    const compensationSelectOptions = compensationOptions.filter(opt => !EXCLUDED_COMPENSATION_OPTIONS.includes(opt.type)).map(opt => ({ value: opt.id, label: opt.name }));
    const compensationSelectCurrentOption = compensationSelectOptions.find(opt => opt.value === form.thirdPartyCompensationOptionId);

    const stationModelOptions = stationModels.map(model => ({ value: model.id, label: model.name }));

    return (
        <>
            <div className="row">
                <div className="col-12 col-md-6">
                    <Form.Label>Seadmete soetamine*</Form.Label>
                        <Select
                            required
                            options={purchaseSelectOptions}
                            value={purchaseSelectCurrentOption ?? null}
                            onChange={(opt: any) => {
                              if(opt.value === FULL_SERVICE_RENT_PURCHASE_OPTION_ID){
                                setForm({
                                  ...form,
                                  purchaseOptionId: opt.value,
                                  devicesFullServiceRentalMonthlyFeeEuros: form.devicesFullServiceRentalMonthlyFeeEuros === undefined ? pricing?.devicesFullServiceRentalMonthlyFeeEuros : form.devicesFullServiceRentalMonthlyFeeEuros,
                                  devicesRentalMonthlyFeeEuros: undefined
                                })
                              }else if(opt.value === RENT_PURCHASE_OPTION_ID){
                                setForm({
                                  ...form,
                                  purchaseOptionId: opt.value,
                                  devicesRentalMonthlyFeeEuros: form.devicesRentalMonthlyFeeEuros === undefined ? pricing?.devicesRentalMonthlyFeeEuros : form.devicesRentalMonthlyFeeEuros,
                                  devicesFullServiceRentalMonthlyFeeEuros: undefined
                              })
                              }else{
                                setForm({
                                  ...form,
                                  purchaseOptionId: opt.value,
                                  devicesFullServiceRentalMonthlyFeeEuros: undefined,
                                  devicesRentalMonthlyFeeEuros: undefined
                              })
                              }
                            }}
                            placeholder='Vali lahendus'
                            className={'w-100 form-control form-select' + (!form.purchaseOptionId && form.validated ? ' is-invalid' : '')}
                        />
                    <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                </div>
                {
                    form.purchaseOptionId === FULL_SERVICE_RENT_PURCHASE_OPTION_ID && (
                        <div className="col-12 col-md-6">
                            <Form.Label>Seadmete täisteenusrendi kuutasu (€/kuu)*</Form.Label>
                            <Form.Control
                                required
                                value={form.devicesFullServiceRentalMonthlyFeeEuros ?? ''}
                                onChange={(e) => setForm({
                                    ...form,
                                    devicesFullServiceRentalMonthlyFeeEuros: onNumberChange(e)
                                })}
                                type="number"
                                onWheel={(e: any) => e.target.blur()}
                            />
                            <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                        </div>
                    )
                }
                {
                    form.purchaseOptionId === RENT_PURCHASE_OPTION_ID && (
                        <div className="col-12 col-md-6">
                            <Form.Label>Seadmete rendi kuutasu (€/kuu)*</Form.Label>
                            <Form.Control
                                required
                                value={form.devicesRentalMonthlyFeeEuros ?? ''}
                                onChange={(e) => setForm({
                                    ...form,
                                    devicesRentalMonthlyFeeEuros: onNumberChange(e)
                                })}
                                type="number"
                                onWheel={(e: any) => e.target.blur()}
                            />
                            <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                        </div>
                    )
                }
            </div>
            <div className="row mt-3">
              <div className="col-12 col-md-6">
                    <Form.Label>Seadme kasutuskoha aadress</Form.Label>
                    <AddressAutocomplete
                        required={false}
                        address={form.address}
                        setAddress={(address) => setForm({
                            ...form,
                            address: address.fullAddress || address.address,
                            city: address.city,
                            zip: address.zip,
                        })}
                        disabled={false}
                    />
                    <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                </div>
            </div>
            {
              !chargerBasedConfig && (
                <>
                  <div className="row mt-3">
                    <div className="col-12 col-md-6">
                        <Form.Label>Laadija hinnastus*</Form.Label>
                            <Select
                                required
                                options={compensationSelectOptions}
                                value={compensationSelectCurrentOption ?? null}
                                onChange={(opt: any) => {
                                  if(opt.value === NETO_COMPENSATION_ID){
                                    setForm({
                                      ...form,
                                      thirdPartyCompensationOptionId: opt.value,
                                      thirdPartyCompensationNetoFeeEuros:  form.thirdPartyCompensationNetoFeeEuros === undefined ? pricing?.thirdPartyCompensationNetoFeeEuros : form.thirdPartyCompensationNetoFeeEuros,
                                      thirdPartyCompensationNetoMarginalCentsKwh:  form.thirdPartyCompensationNetoMarginalCentsKwh === undefined ? pricing?.thirdPartyCompensationNetoMarginalCentsKwh : form.thirdPartyCompensationNetoMarginalCentsKwh,
                                      marketPriceChargingPersonalIdentificationCodes: undefined
                                    })
                                  }else{
                                    setForm({
                                      ...form,
                                      thirdPartyCompensationOptionId: opt.value,
                                      thirdPartyCompensationNetoMarginalCentsKwh: undefined,
                                      marketPriceChargingPersonalIdentificationCodes: undefined
                                    })
                                  }
                                }}
                                placeholder='Vali hinnastus'
                                className={'w-100 form-control form-select' + (!form.thirdPartyCompensationOptionId && form.validated ? ' is-invalid' : '')}
                            />
                        <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                    </div>
                    {
                        form.thirdPartyCompensationOptionId === MARKET_PRICE_COMPENSATION_ID && (
                              <div className="col-12 col-md-6">
                                  <Form.Label>Börsihinnaga laadimise klientide isikukoodid</Form.Label>
                                  <Form.Control
                                      value={form.marketPriceChargingPersonalIdentificationCodes?.join(",")}
                                      onChange={(e: any) => setForm({
                                          ...form,
                                          marketPriceChargingPersonalIdentificationCodes: !e.target.value ? undefined : e.target.value.trim().split(",")
                                      })}
                                      as="textarea"
                                      rows={1}
                                      isInvalid={form.validated && !validateCommaSeparatedPersonalIdentificationCodes(form.marketPriceChargingPersonalIdentificationCodes)}
                                      onWheel={(e: any) => e.target.blur()}
                                  />
                                  <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                              </div>
                          )
                    }
                </div>
                {
                    form.thirdPartyCompensationOptionId === NETO_COMPENSATION_ID && (
                      <div className="row mt-3">
                            <div className="col-12 col-md-6">
                              <Form.Label>Kolmanda osapoole neto marginaal (s/kWh)</Form.Label>
                              <Form.Control
                                  required
                                  placeholder={pricing?.thirdPartyCompensationNetoMarginalCentsKwh.toString() ?? ""}
                                  value={form.thirdPartyCompensationNetoMarginalCentsKwh}
                                  onChange={(e: any) => setForm({
                                      ...form,
                                      thirdPartyCompensationNetoMarginalCentsKwh: onNumberChange(e)
                                  })}
                                  type="number"
                                  onWheel={(e: any) => e.target.blur()}
                              />
                              <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                          </div>
                          <div className="col-12 col-md-6">
                              <Form.Label>Kolmanda osapoole neto kompensatsioon (€)</Form.Label>
                              <Form.Control
                                  required
                                  placeholder={pricing?.thirdPartyCompensationNetoFeeEuros.toString() ?? ""}
                                  value={form.thirdPartyCompensationNetoFeeEuros}
                                  onChange={(e: any) => setForm({
                                      ...form,
                                      thirdPartyCompensationNetoFeeEuros: onNumberChange(e)
                                  })}
                                  type="number"
                                  onWheel={(e: any) => e.target.blur()}
                              />
                              <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                          </div>
                        </div>
                    )
                }
                </>
              )
            }
            <h2 className="my-3">Laadimisjaamad</h2>
            <div>
              {form.chargingStations?.map((station, index) => (
                <ChargingStationForm
                  key={index}
                  form={form}
                  setForm={setForm}
                  station={station}
                  index={index}
                  stationModelOptions={stationModelOptions}
                  compensationOptions={compensationOptions}
                  chargerBasedConfig={chargerBasedConfig}
                />
              ))}
            </div>
            <Button
              variant="primary"
              onClick={(e: any) => {
                e.preventDefault();
                setForm({
                  ...form,
                  chargingStations: [
                    ...form.chargingStations,
                    {}
                  ]
                })
              }}
              type="button"
              className="d-flex align-items-center mt-3 mb-2"
              >
               Lisa uus +
            </Button>
            {
              chargerBasedConfig && form.validated && form.chargingStations.length === 0 && (
                <div className="text-danger">Lisa vähemalt üks laadimisjaam!</div>
              )
            }
        </>
    );
}
